import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
	//public root_url:string = 'http://101.53.155.130:1337/amsuser/';
	public root_url:string = 'https://psapi.pareekshn.com/amsuser/';
	//public root_url:string = 'http://localhost:1337/amsuser/';

	/* previous route */
	public prevRoute: string = '';

	/* Student id */
	public studentId = 0;

	/* batch id */
	public batchId = 0;

	/* view type */
	public viewType = '';

	public isOpenStatusModal = false;

	/* status modal open */
	public statusOpen(statusMsg:string , next:string = '', type:string = ''){
		this.isOpenStatusModal = true;
		document.getElementById('statusMsg').innerHTML = statusMsg;
		if(type != '' && type == 'success')
			document.getElementById('msg-type').innerHTML = '<i class="fa fa-check-circle" style="font-size:48px;color:green"></i>';
		else
			document.getElementById('msg-type').innerHTML = '<i class="fa fa-warning" style="font-size:48px;color:red"></i>';

        let infomodal = document.getElementById('ams-status');
        infomodal.style.display = 'block';

        if(typeof next != 'undefined' && next != '')
        	this.prevRoute = next;
        else
        	this.prevRoute = '';
    }
}